import { useState, useContext, useEffect, useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/userContext';
import LoginForm from '../../components/Login/LoginForm/LoginForm';
import RegisterForm from '../../components/Login/RegisterForm/RegisterForm';
import FullScreen from '../../components/Common/FullScreen/FullScreen';
import Container from '../../components/Common/Container/Container';
import { LoginPageAction, Spacing } from '../../types/appTypes';
import ForgotPasswordForm from '../../components/Login/ForgotPasswordForm/ForgotPasswordForm';

const LoginPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, fetchUser } = useContext(UserContext);
  const [action, setAction] = useState(LoginPageAction.Login);

  const doRedirect = useCallback(() => {
    const redirectTo = searchParams.get('redirectTo');
    navigate(redirectTo ? redirectTo : '/');
  }, [searchParams, navigate]);

  const checkUser = useCallback(async () => {
    if (user) {
      doRedirect();
    } else {
      const fetchedUser = await fetchUser!();
      if (fetchedUser) {
        doRedirect();
      }
    }
  }, [user, fetchUser, doRedirect]);

  useEffect(() => {
    checkUser();
  }, [checkUser]);

  const changeActionHandler = (action: LoginPageAction) => {
    setAction(action);
  };

  const loginSuccessHandler = () => {
    doRedirect();
  };

  let displayForm = undefined;
  switch (action) {
    case LoginPageAction.Register:
      displayForm = <RegisterForm onCancel={changeActionHandler} />;
      break;
    case LoginPageAction.ForgotPassword:
      displayForm = <ForgotPasswordForm onCancel={changeActionHandler} />;
      break;
    default:
      displayForm = (
        <LoginForm
          onRegister={changeActionHandler}
          onResetPassword={changeActionHandler}
          onLoginSuccess={loginSuccessHandler}
        />
      );
  }

  return (
    <FullScreen>
      <Container margin={[Spacing.Auto]}>{displayForm}</Container>
    </FullScreen>
  );
};

export default LoginPage;
